/** Shared domains and tick values for daily detail and its 3D comparison. */
export function detailMetricScales(series, oxygenKey = 'so2') {
  const values = key => (series[key] || []).map(sample => sample.value).filter(Number.isFinite);
  const oxygenHigh = Math.max(120, ...values('oxy'));
  const cumulative = Math.max(0, ...values('ppaC'));
  const rateMax = Math.max(1, ...values('tasa'));
  const curMax = Math.max(30, ...values('cur').map(value => Math.ceil(value / 5) * 5));
  const depthMax = Math.max(0, ...values('dep'));
  const scale = (lo, hi, unit, digits, ticks) => ({ lo, hi, unit, digits, values: ticks });
  return {
    act: scale(0, 100, '%', 0, [0, 25, 50, 75, 100]),
    tasa: scale(0, rateMax, 'kg/min', 1, [0, rateMax / 2, rateMax]),
    ppa: scale(0, Math.max(cumulative, 1), 'pellets', 0, [0, cumulative / 2, cumulative]),
    oxy: scale(0, oxygenHigh, oxygenKey === 'o2' ? 'mg/L' : '%', 1, [0, oxygenHigh / 2, oxygenHigh]),
    temp: scale(5, 15, '°C', 2, [5, 10, 15]),
    cur: scale(0, curMax, 'cm/s', 0, [0, curMax / 2, curMax]),
    dep: scale(depthMax + 0.5, 0, 'm', 1, [0, depthMax / 2, depthMax]),
  };
}
